export default __webpack_public_path__ + "static/media/aboutApplication.2c7dca1b.svg";